import { useMemo, useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { HandIcon2, HourglassIcon } from '../../../../components/Icon';
import Text from '../../../../components/Text';
import { getUserInfo, initValue } from '../../../../utils';
import { LoginPop } from '../../../../components/Login';
import { ReactComponent as RunIcon } from '../../../../static/images/RunIcon.svg';
import { ReactComponent as StandIcon } from '../../../../static/images/StandIcon.svg';
import { useQuery } from '../../../../utils/useQuery';

const useStyles = makeStyles((theme) => ({
  hand: {
    borderRadius: '4px',
    backgroundColor: '#538FFF',
    padding: '0.625rem 0.5rem',
    display: 'flex',
  },
  handIcon: {
    color: '#FFF',
  },
  runIcon: {
    fontSize: '1.5rem',
    color: '#538fff',
  },
}));

const HandingUI = ({
  handlingByHospCode,
  handlingByWardName,
  time,
  NEXT_BUS_STOP_STEP,
  hold,
  WARD_ASSIGN_TITLE,
  handleHanding,
}) => {
  const classes = useStyles({});
  const userInfo = getUserInfo();
  const [isShowLoginPop, setIsShowLoginPop] = useState(false);
  const loginInfo = useSelector((state) => state.loginInfo);
  const query = useQuery();

  const highlight = useMemo(() => {
    return userInfo.hospCode === handlingByHospCode && userInfo.wardName === handlingByWardName;
  }, [userInfo, handlingByHospCode, handlingByWardName]);

  return (
    <Box display="inline-flex" flexDirection="column" gridGap="0.1rem" alignItems="flex-start">
      {highlight ? (
        <ButtonBase
          disabled={
            !(
              NEXT_BUS_STOP_STEP === 'Ward Assign' ||
              NEXT_BUS_STOP_STEP === 'Ward Calling' ||
              NEXT_BUS_STOP_STEP === 'Ward Ack.'
            ) || query.tableName === 'BS'
          }
          onClick={loginInfo.flag ? handleHanding : () => setIsShowLoginPop(true)}
        >
          <div className={classes.hand}>
            <HandIcon2 className={classes.handIcon} />
            <Text fontSize="1rem" color="#FFF">
              {`${initValue(handlingByHospCode, '')} ${initValue(handlingByWardName, '')}`}
            </Text>
          </div>
        </ButtonBase>
      ) : (
        <Text fontSize="1rem" color="#333">
          {`${initValue(handlingByHospCode, '')} ${initValue(handlingByWardName, '')}`}
        </Text>
      )}

      {/* <Text>{initValue(time, '')}</Text> */}

      {NEXT_BUS_STOP_STEP && (
        <Box display="flex" justifyContent="center" alignItems="center" gridGap="0.32rem">
          {/* {hold ? <StandIcon className={classes.runIcon} /> : <RunIcon className={classes.runIcon} />} */}
          <HourglassIcon className={classes.runIcon} />
          <Text fontSize="0.875rem">{initValue(NEXT_BUS_STOP_STEP, '')}</Text>
        </Box>
      )}
      {isShowLoginPop && (
        <LoginPop closehandle={() => setIsShowLoginPop(false)} submitHandle={() => setIsShowLoginPop(false)} />
      )}
    </Box>
  );
};

export default HandingUI;
